 
import { matchPath } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import MyRoutes from "../utils/MyRoutes";


const IsLoggedIn = () => {
  const { auth } = useAuth();

  try {
    const val = auth?.accessToken;
    return !!val;
  } catch {
    return false;
  }
};

const IsRouteRoleMatches = (roles) => {
const { auth } = useAuth();
 
  if (!roles) {       
    return true;
  }

  // if(!roles){
  //   return false;
  // }else if( roles.filter((item) => item === 'All').length > 0){
  //   return true;
  // }

  const userRoles = auth?.roles; 
  const filtered = roles.filter((item) => item === userRoles);
  return !!filtered.length;
};

const getRolesForPath = (pathname) => { 
   var seclayouts = getSecLayouts(); 
   for (const [index, obj] of Object.entries(seclayouts)) {    
    if (matchPath(obj.path, pathname)) {      
        return obj.roles;  
    }

  // for (const [path, obj] of Object.entries(routeConfig)) {
  //   if (matchPath(path, pathname)) {
  //     return obj.roles;
  //   }
  }
  return null;
};

const getSecLayouts =()=>{
  var securedRoutes = MyRoutes.filter(route=> route.secured==true);
  var seclayouts = securedRoutes.filter(sec=> sec.children.length>0)[0];
 var ly =  seclayouts.children.filter(sec=>sec.children);

return ly[0].children;
  
}

const IsMainMenuHasChildrens =   (groupName) => {
  const { auth } = useAuth();

  var seclayouts = getSecLayouts(); 
  var menus = seclayouts.filter(menu=> menu.group === groupName);
  const userRoles = auth?.roles;
   for (const [index, obj] of Object.entries(menus)) {
   var menu = obj.roles?.filter(role=> role === userRoles);
   
   if(menu.length > 0){
    return true;
   }  

  }

  return false;
};
const isPathAllowed = (pathname) => {
  const roles = getRolesForPath(pathname);
  return IsRouteRoleMatches(roles);  
};

 

export { IsLoggedIn, isPathAllowed, IsMainMenuHasChildrens };
